import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { BackendError } from '../model/backend-error';
import { ToastService } from './toast.service';
import { ToastMessage } from '../model/toast-message';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  readonly clientError = 'CORE.CLIENT_ERROR';

  constructor(
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {}

  handleError(error: HttpErrorResponse): Observable<null> {
    let toastMessage: ToastMessage;

    // Client or Network Error
    if (error.status === 0) {
      toastMessage = {
        message: this.translateService.instant(this.clientError),
      } as ToastMessage;
    } else {
      // Backend Error, unsuccessful response code is returned.
      let message: string;
      if (typeof error.error === 'object') {
        const backendError = error.error as BackendError;
        message = backendError.errorKey ? this.translateService.instant(backendError.errorKey) : backendError.error;
      } else {
        message = error.error;
      }
      toastMessage = { message } as ToastMessage;
    }
    this.toastService.error(toastMessage);
    return of(null);
  }
}
